import React from 'react'
import ProfileCard from './components/ProfileCard'
import Navbar from './components/Navbar'
import AllRoutes from './Routes'
const App = () => {
return (
<div className='app-container'>
  <div className="profile-section">
    <ProfileCard />
  </div>
  <div className="page-content">
    <Navbar />
    <div className="route-container">
      <AllRoutes />
    </div>
  </div>
</div>
)
}

export default App
